import type { ChatHistory } from '@cobliteam/api-lib';

import { useUser } from '@cobliteam/hooks';

import { Loading, Typography } from '@cobliteam/ui/components';

import ChatItemFeedback from './components/ChatItemFeedback';

import coblinatorLogo from '../../resources/coblinatorLogo.webp';

interface ChatDisplayProps {
  userPrompt: string | undefined;
  aiResponse: ChatHistory | undefined;
  isLoading: Boolean;
}

const ChatDisplay = ({ userPrompt, aiResponse, isLoading }: ChatDisplayProps) => {
  const { user } = useUser();
  const userInitial = user?.name.charAt(0).toUpperCase() || 'U';

  const responseWithLineBreaks = aiResponse?.content.split('\n');

  return (
    <div className='flex flex-col gap-4 h-full'>
      <div className='flex gap-2.5'>
        <div className='bg-gray-light w-8 h-8 rounded-full text-gray-dark justify-center flex items-center'>{userInitial}</div>

        <div className='w-5/6'>
          <Typography variant='description-title' color='secondary'>
            Você
          </Typography>
          <Typography variant='input-text' color='secondary'>
            {userPrompt}
          </Typography>
        </div>
      </div>

      {aiResponse && (
        <div className='flex gap-2.5'>
          <div className='h-8 w-8'>
            <img src={coblinatorLogo} className='h-8 w-8' />
          </div>
          <div className='w-5/6'>
            <Typography variant='description-title' color='secondary'>
              Coblinator
            </Typography>
            {responseWithLineBreaks?.map((response, index) => (
              <Typography variant='input-text' color='secondary' key={index}>
                {response}
              </Typography>
            ))}
          </div>
        </div>
      )}
      {isLoading && !aiResponse && (
        <div className='m-4'>
          <Loading />
        </div>
      )}
      {!isLoading && !aiResponse && (
        <div className='m-4'>
          <Typography variant='input-text' color='secondary'>
            Um erro ocorreu durante a execução da sua pergunta. Tente novamente.
          </Typography>
        </div>
      )}
      <ChatItemFeedback selectedAIResponse={aiResponse} />
    </div>
  );
};

export default ChatDisplay;
